import {Injectable} from '@angular/core';
import {ItemActionsDirective} from "../../directives/item-actions.directive";

@Injectable({
  providedIn: 'root'
})
export class ItemActionsService {

  private currentActiveDirective: ItemActionsDirective | null = null;
  onExternalCloseTriggerHandler = this.onExternalCloseTrigger.bind(this);

  scrollEventOffset = 0;
  constructor() { }

  activate(directive: ItemActionsDirective) {
    this.scrollEventOffset = 0;
    if(this.currentActiveDirective === directive) {
      console.log("Same directive active => destroying");
      this.destroyDirective(this.currentActiveDirective);
      return;
    }

    if(this.currentActiveDirective !== null) {
      console.log("Any directive is active => destroying");

      this.destroyDirective(this.currentActiveDirective);
    }

    this.currentActiveDirective = directive;
    console.log("Set new active directive");
    this.currentActiveDirective.show();

  }

  deactivate(directive: ItemActionsDirective) {
    this.destroyDirective(directive);
  }

  private destroyDirective(directive: ItemActionsDirective) {
    directive.hide();
    document.removeEventListener("click", this.onExternalCloseTriggerHandler);
    document.removeEventListener("scroll", this.onExternalCloseTriggerHandler);

    if(this.currentActiveDirective === directive) {
      this.currentActiveDirective = null;
    }
  }


  onExternalCloseTrigger($event: any) {
    if(this.currentActiveDirective !== null) {
      if("type" in $event) {
        if($event.type === "scroll") {
          this.scrollEventOffset++;
          if(this.scrollEventOffset < 100) {
            return;
          }
        }
      }
      this.destroyDirective(this.currentActiveDirective);
      document.removeEventListener("click", this.onExternalCloseTriggerHandler);
      document.removeEventListener("scroll", this.onExternalCloseTriggerHandler);
    }
  }


}
